import { Pipe, PipeTransform } from '@angular/core';
import DateUtils from '@shared/utils/date-utils';

@Pipe({ name: 'hqDateOptionalTime' })
export class HqDateOptionalTimePipe implements PipeTransform {

  transform(val: any): any {
    return DateUtils.utc2HQDateOptionalTime(val);
  }

}
